/**
 * Internationalization (i18n) System
 * Simple translation management for ES/EN
 */

// Translation dictionaries
const translations = {
  es: {
    // Navigation
    missions: 'Misiones',
    inventory: 'Inventario',
    travel: 'Viajes',
    stats: 'Stats',
    combat: 'Combate',
    shop: 'Tienda',
    economy: 'Economía',
    consume: 'Consumo',
    rest: 'Descanso',
    crafting: 'Crafteo',
    house: 'Casa',
    rewards: 'Recompensas',
    daily: 'Daily',
    admin: 'Admin',
    settings: 'Ajustes',
    
    // Settings Panel
    'settings.title': 'Ajustes',
    'settings.audio': 'Audio',
    'settings.audio.description': 'Activar/desactivar todos los sonidos del juego',
    'settings.theme': 'Tema',
    'settings.theme.light': 'Claro',
    'settings.theme.dark': 'Oscuro',
    'settings.theme.system': 'Sistema',
    'settings.language': 'Idioma',
    'settings.language.es': 'Español',
    'settings.language.en': 'English',
    'settings.accessibility': 'Accesibilidad',
    'settings.textLarge': 'Texto grande',
    'settings.textLarge.description': 'Aumentar el tamaño del texto para mejor legibilidad',
    'settings.contrastHigh': 'Alto contraste',
    'settings.contrastHigh.description': 'Activar modo de alto contraste para mejor visibilidad',
    'settings.close': 'Cerrar',
    'settings.reset': 'Restablecer',
    'settings.resetConfirm': '¿Estás seguro de que quieres restablecer todos los ajustes?',
    
    // Common UI
    loading: 'Cargando...',
    error: 'Error',
    success: 'Éxito',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    save: 'Guardar',
    delete: 'Eliminar',
    edit: 'Editar',
    refresh: 'Actualizar',
    
    // Auth
    login: 'Iniciar Sesión',
    register: 'Registrarse',
    logout: 'Cerrar Sesión',
    email: 'Email',
    password: 'Contraseña',
    username: 'Nombre de usuario',
    
    // Game specific
    health: 'Salud',
    thirst: 'Sed',
    hunger: 'Hambre',
    level: 'Nivel',
    coins: 'Monedas',
    experience: 'Experiencia',
    
    // Missions
    'missions.available': 'Misiones Disponibles',
    'missions.active': 'Misión Activa',
    'missions.completed': 'Misión Completada',
    'missions.accept': 'Aceptar Misión',
    'missions.claim': 'Reclamar Recompensas',
    'missions.cancel': 'Cancelar Misión',
    
    // Travel
    'travel.planning': 'Planear Viaje',
    'travel.destinations': 'Destinos Disponibles',
    'travel.active': 'Viaje Activo',
    'travel.start': 'Iniciar Viaje',
    'travel.cancel': 'Cancelar Viaje',
    
    // Inventory
    'inventory.equipment': 'Equipamiento',
    'inventory.use': 'Usar',
    'inventory.equip': 'Equipar',
    'inventory.sell': 'Vender',
    'inventory.repair': 'Reparar',
    'inventory.discard': 'Desechar',
    
    // Network status
    'offline.banner': 'Sin conexión',
    'offline.readonly': 'Solo lectura',
    'offline.unavailable': 'No disponible sin conexión',
    
    // Errors
    'error.network': 'Error de conexión',
    'error.server': 'Error del servidor',
    'error.unknown': 'Error desconocido'
  },
  
  en: {
    // Navigation
    missions: 'Missions',
    inventory: 'Inventory',
    travel: 'Travel',
    stats: 'Stats',
    combat: 'Combat',
    shop: 'Shop',
    economy: 'Economy',
    consume: 'Consume',
    rest: 'Rest',
    crafting: 'Crafting',
    house: 'House',
    rewards: 'Rewards',
    daily: 'Daily',
    admin: 'Admin',
    settings: 'Settings',
    
    // Settings Panel
    'settings.title': 'Settings',
    'settings.audio': 'Audio',
    'settings.audio.description': 'Enable/disable all game sounds',
    'settings.theme': 'Theme',
    'settings.theme.light': 'Light',
    'settings.theme.dark': 'Dark',
    'settings.theme.system': 'System',
    'settings.language': 'Language',
    'settings.language.es': 'Español',
    'settings.language.en': 'English',
    'settings.accessibility': 'Accessibility',
    'settings.textLarge': 'Large text',
    'settings.textLarge.description': 'Increase text size for better readability',
    'settings.contrastHigh': 'High contrast',
    'settings.contrastHigh.description': 'Enable high contrast mode for better visibility',
    'settings.close': 'Close',
    'settings.reset': 'Reset',
    'settings.resetConfirm': 'Are you sure you want to reset all settings?',
    
    // Common UI
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    refresh: 'Refresh',
    
    // Auth
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    email: 'Email',
    password: 'Password',
    username: 'Username',
    
    // Game specific
    health: 'Health',
    thirst: 'Thirst',
    hunger: 'Hunger',
    level: 'Level',
    coins: 'Coins',
    experience: 'Experience',
    
    // Missions
    'missions.available': 'Available Missions',
    'missions.active': 'Active Mission',
    'missions.completed': 'Mission Completed',
    'missions.accept': 'Accept Mission',
    'missions.claim': 'Claim Rewards',
    'missions.cancel': 'Cancel Mission',
    
    // Travel
    'travel.planning': 'Plan Travel',
    'travel.destinations': 'Available Destinations',
    'travel.active': 'Active Travel',
    'travel.start': 'Start Travel',
    'travel.cancel': 'Cancel Travel',
    
    // Inventory
    'inventory.equipment': 'Equipment',
    'inventory.use': 'Use',
    'inventory.equip': 'Equip',
    'inventory.sell': 'Sell',
    'inventory.repair': 'Repair',
    'inventory.discard': 'Discard',
    
    // Network status
    'offline.banner': 'Offline',
    'offline.readonly': 'Read only',
    'offline.unavailable': 'Unavailable offline',
    
    // Errors
    'error.network': 'Network error',
    'error.server': 'Server error',
    'error.unknown': 'Unknown error'
  }
};

export class I18nManager {
  constructor() {
    this.currentLanguage = 'es'; // Default fallback
    this.fallbackLanguage = 'es';
  }

  // Set current language
  setLanguage(language) {
    if (language in translations) {
      this.currentLanguage = language;
      return true;
    }
    return false;
  }

  // Get current language
  getLanguage() {
    return this.currentLanguage;
  }

  // Get available languages
  getAvailableLanguages() {
    return Object.keys(translations);
  }

  // Translate a key
  t(key, fallback = null) {
    // Try current language first
    const currentDict = translations[this.currentLanguage];
    if (currentDict && key in currentDict) {
      return currentDict[key];
    }
    
    // Try fallback language
    if (this.currentLanguage !== this.fallbackLanguage) {
      const fallbackDict = translations[this.fallbackLanguage];
      if (fallbackDict && key in fallbackDict) {
        return fallbackDict[key];
      }
    }
    
    // Use provided fallback or return key itself
    return fallback || key;
  }

  // Translate with parameters (simple interpolation)
  tp(key, params = {}, fallback = null) {
    let text = this.t(key, fallback);
    
    // Simple parameter replacement
    for (const [param, value] of Object.entries(params)) {
      text = text.replace(`{${param}}`, value);
    }
    
    return text;
  }

  // Check if translation exists
  has(key) {
    const currentDict = translations[this.currentLanguage];
    if (currentDict && key in currentDict) {
      return true;
    }
    
    if (this.currentLanguage !== this.fallbackLanguage) {
      const fallbackDict = translations[this.fallbackLanguage];
      return fallbackDict && key in fallbackDict;
    }
    
    return false;
  }

  // Get all translations for current language
  getAll() {
    const currentDict = translations[this.currentLanguage] || {};
    const fallbackDict = translations[this.fallbackLanguage] || {};
    
    // Merge fallback with current (current takes precedence)
    return { ...fallbackDict, ...currentDict };
  }

  // Initialize with settings language
  init(language = 'es') {
    this.setLanguage(language);
    console.log(`i18n initialized with language: ${this.currentLanguage}`);
  }
}

// Singleton instance
export const i18n = new I18nManager();

// Helper function for components
export const t = (key, fallback = null) => i18n.t(key, fallback);
export const tp = (key, params = {}, fallback = null) => i18n.tp(key, params, fallback);